import { useTranslation } from 'react-i18next';

import { DealTableCell } from '@crm/entities/deal';
import { Progress, ProgressValue } from '@crm/shared/ui';
import { formatPrice } from '@shared/helpers';

import type { TInWorkOrFinishedDeal } from '@crm/entities/deal';

export const DealProcessCell = ({
    currency,
    earnedAmount,
    percent,
}: {
    currency: TInWorkOrFinishedDeal['progress']['currency'];
    earnedAmount: TInWorkOrFinishedDeal['progress']['earnedAmount'];
    percent: TInWorkOrFinishedDeal['progress']['percent'];
}) => {
    const { t } = useTranslation();
    const formattedEarnedAmount = formatPrice(earnedAmount, {
        currencyCode: currency,
        withCurrency: true,
    });

    return (
        <DealTableCell className="px-1 whitespace-nowrap">
            <div className="flex flex-col gap-1">
                <Progress
                    value={percent}
                    aria-label={t('crm.inWorkOrFinishedPage.progress.ariaLabel')}
                    className="flex-nowrap items-center gap-2 **:data-[slot=progress-indicator]:min-w-[2%] **:data-[slot=progress-indicator]:bg-smtr-main-green-100 **:data-[slot=progress-track]:h-2 **:data-[slot=progress-track]:bg-smtr-main-green-10"
                >
                    <ProgressValue className="order-1 ml-0 text-xs leading-none text-smtr-main-black-100" />
                </Progress>
                <span className="text-center text-xs leading-none text-smtr-main-tertiary-100">
                    {t('crm.inWorkOrFinishedPage.progress.earned', {
                        amount: formattedEarnedAmount,
                    })}
                </span>
            </div>
        </DealTableCell>
    );
};
